import React, {useContext, useEffect} from "react";
import {connect} from "react-redux";
import {PlatformContext} from "../context/PlatformContext";
import {DESKTOP, MOBILE} from "../actions/mobile";

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

const PlatformService = () => {
    const { platform, setPlatform } = useContext(PlatformContext);

    // Check window size to switch between desktop and mobile app version
    useEffect(() => {
        const handleResize = () => {
            setPlatform((window.innerWidth <= 770) ? MOBILE : DESKTOP);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (<div/>);
}

export default connect(mapStateToProps, mapDispatchToProps)(PlatformService);


// WEBPACK FOOTER //
// ./src/functional/PlatformService.js